module.exports = __webpack_public_path__ + "img/04.e6d80615.jpg";